export default {
  tipoPessoa: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  name: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  document: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  numSisbr: {
    value: '',
    maxlength: '70',
    required: false,
    state: null
  },
  dataNascimento: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  },
  email: {
    value: '',
    maxlength: '70',
    required: false,
    state: null
  },
  phone: {
    value: '',
    maxlength: '13',
    required: false,
    state: null
  },
  cellPhone: {
    value: '',
    maxlength: '14',
    required: false,
    state: null
  },
  leadOriginID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  description: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '3',
    noResize: true
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/person/person-form.js